import React from 'react';
import { Box, Card, CardContent, Chip, Divider, LinearProgress, Stack, Typography } from '@mui/material';
import { ObsazeneVozidlo, ObsazeniVysledek, PrirazenaOsoba } from '../../api/JsdhNotifikaceService/generated/models/Obsazeni';

const varovaniLabel: Record<string, string> = {
    CHYBI_STROJNIK: 'Chybí strojník',
    CHYBI_VELITEL: 'Chybí velitel',
    POD_MINIMEM: 'Pod minimem',
};

const roleLabel: Record<string, string> = {
    VELITEL: 'Velitel',
    STROJNIK: 'Strojník',
    CLEN: 'Hasič',
};

const VozidloCard: React.FC<{ vozidlo: ObsazeneVozidlo }> = ({ vozidlo }) => {
    const obsazeno = vozidlo.obsazeni.length;
    const max = vozidlo.maxOsob ?? obsazeno;
    const procent = max > 0 ? Math.min(100, (obsazeno / max) * 100) : 0;
    const maVarovani = vozidlo.varovani.length > 0;
    return (
        <Card variant="outlined" sx={{ borderColor: maVarovani ? 'warning.main' : undefined }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {vozidlo.volaciZnak} — {vozidlo.nazev}
                    </Typography>
                    <Typography variant="body2">
                        {obsazeno}/{vozidlo.maxOsob ?? '—'}
                        {vozidlo.minOsob != null ? ` (min ${vozidlo.minOsob})` : ''}
                    </Typography>
                </Box>
                <LinearProgress variant="determinate" value={procent} sx={{ mb: 1, height: 8, borderRadius: 1 }} />
                {maVarovani && (
                    <Stack direction="row" spacing={1} sx={{ mb: 1 }} flexWrap="wrap" useFlexGap>
                        {vozidlo.varovani.map((v) => (
                            <Chip key={v} label={varovaniLabel[v] ?? v} color="warning" size="small" />
                        ))}
                    </Stack>
                )}
                <Stack spacing={0.5}>
                    {vozidlo.obsazeni.map((o: PrirazenaOsoba) => (
                        <Box key={o.uzivatelId} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body2">{o.jmeno}</Typography>
                            <Chip
                                label={roleLabel[o.role] ?? o.role}
                                size="small"
                                variant="outlined"
                                color={o.role === 'CLEN' ? 'default' : 'primary'}
                            />
                        </Box>
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
};

const ObsazeniVysledekView: React.FC<{ data: ObsazeniVysledek }> = ({ data }) => {
    return (
        <Stack spacing={2}>
            {data.vozidla.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                    Žádná povolaná dostupná vozidla k obsazení.
                </Typography>
            )}
            {data.vozidla.map((v) => (
                <VozidloCard key={v.technikaId} vozidlo={v} />
            ))}
            {data.nezarazeni.length > 0 && (
                <Box>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="subtitle2" gutterBottom>
                        Nezařazení ({data.nezarazeni.length})
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {data.nezarazeni.map((o) => (
                            <Chip key={o.uzivatelId} label={o.jmeno} size="small" />
                        ))}
                    </Stack>
                </Box>
            )}
        </Stack>
    );
};

export default ObsazeniVysledekView;
